import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { propertyIncomeSelector } from '../selectors'
import { handleRequestError } from './request'
import { updateAndSaveActiveTaxReturn } from './tax-return'

export const REQUEST_PROPERTY_INCOME_SUMMARY = 'REQUEST_PROPERTY_INCOME_SUMMARY'
export const RECEIVE_PROPERTY_INCOME_SUMMARY = 'RECEIVE_PROPERTY_INCOME_SUMMARY'
export const SAVE_PROPERTY_INCOME_SUMMARY = 'SAVE_PROPERTY_INCOME_SUMMARY'
const CREATE_PROPERTY_INCOME_SUMMARY = 'CREATE_PROPERTY_INCOME_SUMMARY'

export const requestPropertyIncomeSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_PROPERTY_INCOME_SUMMARY, data: { taxReturnId } })

    axios
        .get(`/propertyincomesummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receivePropertyIncomeSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receivePropertyIncomeSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receivePropertyIncomeSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receivePropertyIncomeSummary = (data) => ({ type: RECEIVE_PROPERTY_INCOME_SUMMARY, data })

export const savePropertyIncomeSummary = (data) => (dispatch) => {
    dispatch({ type: SAVE_PROPERTY_INCOME_SUMMARY, data })

    const { taxReturnId } = data

    return axios
        .put(`/propertyincomesummaries/${taxReturnId}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receivePropertyIncomeSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSavePropertyIncomeSummary = (data) => (dispatch, getState) => {
    const { propertyIncomeSummary } = propertyIncomeSelector(getState())
    const updatedPropertyIncomeSummary = { ...propertyIncomeSummary, ...data }

    dispatch(receivePropertyIncomeSummary(updatedPropertyIncomeSummary))
    return dispatch(savePropertyIncomeSummary(updatedPropertyIncomeSummary)).catch(() => {})
}

export const updateAndSavePropertyIncomeSummaryStatus =
    ({ status }) =>
    (dispatch, getState) => {
        const { propertyIncomeSummary } = propertyIncomeSelector(getState())
        const updatedPropertyIncomeSummary = { ...propertyIncomeSummary, status }

        dispatch(receivePropertyIncomeSummary(updatedPropertyIncomeSummary))
        return dispatch(savePropertyIncomeSummary(updatedPropertyIncomeSummary))
            .then(() => dispatch(updateAndSaveActiveTaxReturn({ propertyIncomeSummaryStatus: status })))
            .catch(() => {})
    }

export const createPropertyIncomeSummary =
    (data = {}) =>
    (dispatch, getState) => {
        const { id } = getState().taxReturn

        dispatch({ type: CREATE_PROPERTY_INCOME_SUMMARY })

        return axios
            .put(`/propertyincomesummaries/${id}`, data)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receivePropertyIncomeSummary(responseData))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const createOrUpdatePropertyIncomeSummary = (data) => (dispatch, getState) => {
    const { hasPropertyIncomeSummary, propertyIncomeSummary } = propertyIncomeSelector(getState())

    const persist = hasPropertyIncomeSummary ? updateAndSavePropertyIncomeSummary : createPropertyIncomeSummary
    return dispatch(persist({ ...propertyIncomeSummary, ...data }))
}
